import React from 'react'
import { cn } from '@/lib/utils'
import { AsyncContentProgress } from '@/shared/ui'
import { useUserDateFormatter } from '@/modules/auth/hooks/useUserTimezone'
import { PostCardAuthorMeta, PostPreviewCard } from '@/modules/post-shared'
import { useTimelineVisions } from '../hooks/useTimelineVisions'

type VisionTimelineHistoryProps = {
  timelineRootId: number | null
  className?: string
}

export function VisionTimelineHistory({
  timelineRootId,
  className,
}: VisionTimelineHistoryProps) {
  const safeRootId =
    timelineRootId != null && Number.isFinite(Number(timelineRootId))
      ? Math.floor(Number(timelineRootId))
      : null
  const { formatUserDateTime } = useUserDateFormatter()
  const { items, loading, error } = useTimelineVisions(safeRootId, safeRootId != null)

  if (safeRootId == null) return null

  if (loading) {
    return (
      <div className="rounded-xl bg-background/20 p-3">
        <AsyncContentProgress loading label="Carregando historico da timeline...">
          {null}
        </AsyncContentProgress>
      </div>
    )
  }

  if (error) {
    return (
      <div className="rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs text-red-200">
        Nao foi possivel carregar o historico da timeline.
      </div>
    )
  }

  if (items.length <= 1) return null

  return (
    <div className={cn('relative pl-8', className)}>
      <div className="absolute left-3 top-0 h-full w-px bg-border/40" />
      <div className="space-y-6">
        {items.map((vision) => (
          <div key={vision.id} className="relative">
            <div className="absolute -left-[17px] top-6 h-3 w-3 rounded-full border border-border bg-[#1b1b1b]" />
            <PostPreviewCard
              title={vision.title}
              contentHtml={vision.contentHtml}
              attachments={vision.attachments}
              lightboxVariant="drawer"
              footer={(
                <div className="flex justify-end">
                  <PostCardAuthorMeta
                    name={vision.authorName}
                    avatarUrl={vision.authorAvatarUrl}
                    dateLabel={vision.createdAt ? formatUserDateTime(vision.createdAt) : null}
                  />
                </div>
              )}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
